import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
// material

// ----------------------------------------------------------------------

ArcadePortal.propTypes = {
  primaryColor: PropTypes.string,
  secondaryColor: PropTypes.string,
  width: PropTypes.string,
  dark: PropTypes.bool
};

export default function ArcadePortal({ primaryColor, secondaryColor, width, dark }) {
  const { formatMessage: msg } = useIntl();

  const color = primaryColor;
  const portalColor = secondaryColor || (dark ? '#B17BB2' : '#904392');
  const mainColor1 = dark ? '#A06D9F' : '#86388C';
  const mainColor2 = dark ? '#96619A' : '#762181';
  const mainColor3 = dark ? '#8B548D' : '#50267E';
  const mainColor4 = dark ? '#6C4E75' : '#292F6D';
  const mainColor5 = dark ? '#53486B' : '#21244C';
  return (
    <svg
      version="1.1"
      id="Calque_1"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      viewBox="0 0 141.3529 55.5882"
      xmlSpace="preserve"
      aria-label={msg({
        id: `product.logo.title`
      })}
    >
      <path
        fill={color}
        d="M58.624,24.3474c0-1.204,0.212-2.4038,0.6354-3.5994c0.4234-1.1944,1.0395-2.2625,1.8487-3.2037
	c0.8089-0.9406,1.8066-1.7074,2.992-2.3004c1.1857-0.5924,2.5307-0.8889,4.0363-0.8889c1.7877,0,3.3168,0.4047,4.5869,1.2136
	c1.2702,0.8095,2.2063,1.8632,2.8086,3.1616l-1.5525,0.9592c-0.3202-0.6585-0.7106-1.2136-1.1712-1.6653
	c-0.4613-0.4517-0.9553-0.8185-1.4819-1.1006c-0.5271-0.2827-1.0726-0.4841-1.6373-0.6068
	c-0.5644-0.1221-1.1198-0.1834-1.6653-0.1834c-1.2046,0-2.2679,0.2448-3.1896,0.7337c-0.9223,0.4895-1.6987,1.1288-2.3289,1.9191
	c-0.6306,0.7908-1.1057,1.6797-1.4253,2.6678c-0.3202,0.9875-0.4799,1.9901-0.4799,3.0058c0,1.1108,0.1927,2.1735,0.5789,3.1899
	c0.3855,1.0164,0.9123,1.9149,1.5805,2.6955c0.6679,0.7812,1.4581,1.4019,2.371,1.8632c0.9126,0.4613,1.9053,0.6916,2.9779,0.6916
	c0.5647,0,1.1433-0.071,1.736-0.2117c0.593-0.1413,1.1667-0.3669,1.7218-0.6778c0.5551-0.3103,1.0678-0.6958,1.5384-1.1571
	c0.4703-0.4607,0.8654-1.0206,1.1857-1.6797l1.637,0.8468c-0.3203,0.753-0.7719,1.4163-1.3547,1.9901
	c-0.5837,0.5743-1.2329,1.0585-1.9477,1.4536c-0.7154,0.3957-1.4728,0.6964-2.2724,0.9033
	c-0.8002,0.2069-1.5856,0.3109-2.3569,0.3109c-1.3739,0-2.6348-0.3013-3.7822-0.9033c-1.1481-0.602-2.1362-1.3874-2.964-2.3569
	c-0.8281-0.9695-1.4725-2.07-1.9335-3.3029C58.8543,26.883,58.624,25.6272,58.624,24.3474z"
      />
      <path
        fill={mainColor2}
        d="M90.5484,28.2713l2.5969,6.266h2.0887l-8.3268-20.0412h-1.6653l-8.3836,20.0412h2.1172l2.5686-6.266
	l4.5163-11.4604L90.5484,28.2713"
      />
      <path
        fill={color}
        d="M98.1129,34.5374V14.4961h6.8028c1.5991,0,2.9965,0.264,4.1915,0.7908c1.195,0.5268,2.1921,1.2419,2.992,2.1452
	c0.7999,0.9033,1.4019,1.9618,1.8066,3.1754c0.4044,1.2136,0.6068,2.5079,0.6068,3.8809c0,1.5246-0.2258,2.903-0.6775,4.1353
	c-0.4517,1.2329-1.0964,2.2865-1.9335,3.1616c-0.8375,0.875-1.8442,1.5522-3.0203,2.0322c-1.176,0.4799-2.4979,0.7199-3.9657,0.7199
	H98.1129z M112.5367,24.4885c0-1.204-0.1693-2.3094-0.5079-3.3162c-0.3389-1.0068-0.8326-1.8776-1.4819-2.6113
	c-0.6492-0.7337-1.4446-1.3026-2.3852-1.7074c-0.9412-0.4047-2.0231-0.6074-3.2461-0.6074h-4.8269v16.5411h4.8269
	c1.2419,0,2.338-0.2117,3.2885-0.6351c0.9499-0.4234,1.745-1.0062,2.3849-1.7501c0.6396-0.7433,1.1243-1.6184,1.4539-2.6251
	C112.3719,26.7708,112.5367,25.6744,112.5367,24.4885z"
      />
      <g>
        <g>
          <rect fill={color} x="117.7515" y="23.7265" width="13.4643" height="1.6653" />
          <rect fill={color} x="117.7091" y="32.7873" width="13.4643" height="1.7501" />
          <rect fill={color} x="117.7515" y="14.4961" width="13.4643" height="1.7501" />
        </g>
      </g>
      <path
        fill={color}
        d="M51.4546,26.8033c0.6775-0.1317,1.2888-0.3813,1.8349-0.7481c0.5455-0.3669,1.0113-0.8185,1.3971-1.355
	c0.3855-0.5359,0.6868-1.1379,0.9033-1.806c0.2162-0.6682,0.3248-1.3694,0.3248-2.1031c0-0.7716-0.1461-1.5336-0.4375-2.2865
	c-0.292-0.7524-0.7012-1.4253-1.2281-2.0183c-0.5268-0.5924-1.1529-1.0723-1.877-1.4392c-0.7247-0.3669-1.5198-0.5509-2.3852-0.5509
	h-8.4681v1.7501h8.3553c0.5455,0,1.0675,0.1227,1.5664,0.3675c0.4986,0.2448,0.9316,0.5737,1.2984,0.9875
	c0.3672,0.4144,0.6585,0.8991,0.875,1.4536c0.2162,0.5557,0.3248,1.1343,0.3248,1.7363c0,0.6026-0.0944,1.1763-0.2824,1.7218
	c-0.1882,0.5461-0.4517,1.035-0.7902,1.4674c-0.3389,0.4336-0.7481,0.7764-1.2281,1.0308
	c-0.4796,0.2538-1.0116,0.3807-1.5946,0.3807h-8.5246v9.1456h1.9759v-7.3955h5.9278l4.7138,7.3955h2.2297L51.4546,26.8033z"
      />
      <g>
        <polyline
          fill={dark ? '#B493AB' : '#934895'}
          points="9.6346,34.6784 12.3389,30.2855 14.9814,34.6784 9.6346,34.6784 	"
        />
        <polygon
          fill={dark ? '#AA7CA6' : '#904392'}
          points="17.6965,30.2855 14.9921,34.6784 12.3496,30.2855 	"
        />
        <polygon fill={mainColor1} points="15.0096,34.6784 17.7139,30.2855 20.3564,34.6784 	" />
        <polygon fill={mainColor2} points="23.0715,30.2855 20.3671,34.6784 17.7246,30.2855 	" />
        <polygon fill={mainColor3} points="20.3747,34.6784 23.079,30.2855 25.7215,34.6784 	" />
        <polygon fill={mainColor4} points="28.4366,30.2855 25.7322,34.6784 23.0897,30.2855 	" />
        <polygon fill={mainColor5} points="25.7483,34.6784 28.4527,30.2855 31.0952,34.6784 	" />
        <polygon
          fill={mainColor1}
          points="24.0784,9.0717 13.0119,28.6991 18.7109,28.6991 23.874,19.5419 26.8925,14.1587 	"
        />
        <polygon
          fill={mainColor3}
          points="27.7992,15.7977 24.9526,20.8741 30.1589,30.2855 30.1525,30.2855 32.5693,34.6642 38.2359,34.6642
		"
        />
      </g>
      <g>
        <g>
          <path
            fill={portalColor}
            d="M94.567,49.4504v-9.6245h3.9849c0.4155,0,0.7973,0.0866,1.1455,0.2576
			c0.3477,0.1721,0.6481,0.4053,0.9011,0.6985c0.253,0.2933,0.4521,0.6191,0.5967,0.9755c0.1441,0.3574,0.2169,0.7209,0.2169,1.0916
			c0,0.5244-0.1156,1.0193-0.3457,1.4846c-0.2306,0.4653-0.5539,0.8421-0.9694,1.1313c-0.4155,0.2892-0.9037,0.4338-1.4637,0.4338
			h-3.1179v3.5516H94.567z M95.5155,45.0587h3.0771c0.3793,0,0.7092-0.1039,0.9892-0.3116c0.28-0.2077,0.4969-0.4796,0.6507-0.8136
			s0.2306-0.6955,0.2306-1.0844c0-0.3971-0.0906-0.7637-0.2714-1.0977s-0.418-0.5987-0.7113-0.7932
			c-0.2938-0.1945-0.6171-0.2912-0.9694-0.2912h-2.9957V45.0587z"
          />
          <path
            fill={portalColor}
            d="M105.1072,49.6261c-0.5152,0-0.9872-0.0967-1.4164-0.2892c-0.4292-0.1935-0.7998-0.4592-1.1114-0.7953
			c-0.3121-0.337-0.5539-0.724-0.7255-1.1598s-0.2576-0.8961-0.2576-1.3818c0-0.503,0.086-0.9724,0.2576-1.4082
			s0.4154-0.8227,0.7321-1.1598c0.3162-0.337,0.6889-0.6018,1.118-0.7952c0.4292-0.1924,0.8971-0.2892,1.4031-0.2892
			c0.5061,0,0.9714,0.0967,1.396,0.2892c0.4246,0.1935,0.7953,0.4582,1.1114,0.7952s0.5605,0.724,0.7321,1.1598
			c0.1716,0.4358,0.2576,0.9052,0.2576,1.4082c0,0.4857-0.086,0.946-0.2576,1.3818c-0.1716,0.4358-0.4134,0.8227-0.725,1.1598
			c-0.3121,0.336-0.6827,0.6018-1.1114,0.7953C106.0807,49.5293,105.6133,49.6261,105.1072,49.6261z M102.5316,46.0133
			c0,0.5213,0.1156,0.9938,0.3457,1.4205c0.2306,0.4256,0.5402,0.7627,0.9286,1.0091c0.3885,0.2464,0.8176,0.3696,1.2876,0.3696
			c0.4699,0,0.8991-0.1252,1.2881-0.3768c0.3885-0.2505,0.7001-0.5936,0.9353-1.0294c0.2347-0.4348,0.3523-0.9123,0.3523-1.4327
			c0-0.5122-0.1176-0.9826-0.3523-1.4133c-0.2352-0.4307-0.5468-0.7718-0.9353-1.0233c-0.389-0.2505-0.8182-0.3768-1.2881-0.3768
			c-0.4699,0-0.8991,0.1303-1.2876,0.391c-0.3885,0.2597-0.698,0.6028-0.9286,1.0294
			C102.6471,45.0063,102.5316,45.4838,102.5316,46.0133z"
          />
          <path
            fill={portalColor}
            d="M113.4764,43.2691c-0.6145,0.0183-1.1547,0.1904-1.62,0.5152c-0.4653,0.3258-0.7927,0.7729-0.9826,1.3421
			v4.3917h-0.9215V42.483h0.8675v1.6669c0.2439-0.4969,0.5667-0.8991,0.9689-1.2056c0.4022-0.3075,0.8294-0.4796,1.281-0.5152
			c0.0906-0.0092,0.1695-0.0132,0.2373-0.0132c0.0677,0,0.1242,0.0041,0.1695,0.0132V43.2691z"
          />
          <path
            fill={portalColor}
            d="M118.4026,49.233c-0.0723,0.0275-0.1853,0.0774-0.3391,0.1497c-0.1538,0.0723-0.3386,0.1354-0.5555,0.1894
			s-0.4521,0.0815-0.7051,0.0815c-0.2622,0-0.5081-0.0499-0.7387-0.1497c-0.2301-0.0998-0.4134-0.2515-0.5488-0.4562
			c-0.1354-0.2036-0.2031-0.4562-0.2031-0.7555v-5.077h-0.976V42.483h0.976v-2.3858h0.9215v2.3858h1.6267v0.7321h-1.6267v4.8214
			c0.0178,0.2546,0.1105,0.445,0.278,0.5723c0.167,0.1273,0.3589,0.1904,0.5758,0.1904c0.253,0,0.4837-0.0428,0.6914-0.1283
			c0.2077-0.0855,0.3345-0.1466,0.3798-0.1833L118.4026,49.233z"
          />
          <path
            fill={portalColor}
            d="M119.2996,47.4989c0-0.4409,0.1263-0.8197,0.3793-1.1384c0.253-0.3187,0.6033-0.5661,1.0503-0.7413
			c0.4475-0.1751,0.9648-0.2627,1.5523-0.2627c0.3431,0,0.7,0.0275,1.0707,0.0815c0.3706,0.054,0.7,0.1354,0.9897,0.2444v-0.5947
			c0-0.5926-0.1762-1.0651-0.529-1.4154c-0.3523-0.3503-0.8401-0.5254-1.4637-0.5254c-0.3793,0-0.7525,0.0703-1.118,0.2108
			c-0.3661,0.1395-0.7479,0.3452-1.1455,0.616l-0.3523-0.6507c0.4608-0.3157,0.9123-0.5529,1.3553-0.7107
			c0.4424-0.1588,0.8945-0.2373,1.3553-0.2373c0.8675,0,1.5544,0.2464,2.0604,0.7403c0.5061,0.4939,0.7591,1.1771,0.7591,2.0477
			v3.2462c0,0.1252,0.027,0.2179,0.0815,0.2759c0.054,0.058,0.14,0.0916,0.2576,0.1008v0.7321
			c-0.0998,0.0092-0.1853,0.0183-0.2576,0.0275c-0.0723,0.0081-0.1268,0.0081-0.1629,0c-0.2255-0.0092-0.3976-0.0815-0.5147-0.2169
			c-0.1176-0.1354-0.1812-0.28-0.1899-0.4338l-0.0137-0.5152c-0.3162,0.4063-0.7275,0.7209-1.2331,0.9419
			c-0.5066,0.221-1.0213,0.3319-1.5457,0.3319c-0.4516,0-0.8604-0.0967-1.2265-0.2892c-0.3661-0.1935-0.6507-0.4541-0.8538-0.782
			C119.4009,48.2555,119.2996,47.894,119.2996,47.4989z M124.0298,48.0355c0.0993-0.1252,0.1762-0.2464,0.2306-0.3625
			c0.054-0.1161,0.0815-0.2199,0.0815-0.3095v-1.0203c-0.3075-0.1171-0.6262-0.2067-0.9556-0.2688
			c-0.3299-0.0631-0.6624-0.0937-0.9964-0.0937c-0.6598,0-1.1929,0.1293-1.5997,0.389c-0.4063,0.2597-0.6099,0.613-0.6099,1.061
			c0,0.2597,0.0677,0.504,0.2037,0.7321c0.1354,0.2281,0.334,0.4165,0.5962,0.5641c0.2622,0.1487,0.5692,0.222,0.9215,0.222
			c0.4429,0,0.8563-0.0855,1.2402-0.2556C123.5263,48.5233,123.8221,48.3044,124.0298,48.0355z"
          />
          <path
            fill={portalColor}
            d="M127.2561,40.9781v-1.3553h0.9215v1.3553H127.2561z M127.2561,49.5181v-7.0626h0.9215v7.0626H127.2561z"
          />
          <path fill={portalColor} d="M130.2518,49.5181v-9.9455h0.9215v9.9455H130.2518z" />
        </g>
      </g>
    </svg>
  );
}
